import { backgroundAnimation } from './background-animation';

const available = [];
const taken = [];

export function retrieveBackgroundAnimation(options) {
  let result;
  if (available.length > 0) {
    [result] = available.splice(0, 1);
    result.updateOptions(options);
  } else {
    result = backgroundAnimation.init(options);
  }
  taken.push(result);
  return result;
}

export function releaseBackgroundAnimation(animation) {
  const index = taken.indexOf(animation);
  if (index > -1) {
    animation.release();
    available.push(...taken.splice(index, 1));
  }
}
